import { EditorNodeType, getWorkflowNodeConfig } from "../nodes";
import { nodeColorToTailwindClasses, NodePalette } from "../lib/node-color-to-tailwind-classes";


export default function useNodePalette(editorNodeType: EditorNodeType): {
  palette: NodePalette;
  classes: string;
  classesWithHover: string;
} {
  const nodeConfig = getWorkflowNodeConfig(editorNodeType);
  const palette = nodeColorToTailwindClasses(nodeConfig?.config.color || "default");
  const { hover, ...noHover } = palette;

  return {
    palette: palette as NodePalette,
    classes: Object.values(noHover || {}).join(" "),
    classesWithHover: Object.values(palette || {}).join(" "),
  };
}
